export type DeviceMode = 'pwa' | 'desktop' | 'mobile-web';

export interface DeviceInfo {
  mode: DeviceMode;
  isPWA: boolean;
  isDesktop: boolean;
  isMobileWeb: boolean;
  isStandalone: boolean;
  isTouch: boolean;
  screenWidth: number;
  screenHeight: number;
}

function detectDevice(): DeviceInfo {
  try {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const mql = window.matchMedia('(display-mode: standalone)');
    const isStandalone = mql?.matches === true
      || (window.navigator as any).standalone === true
      || (typeof document.referrer === 'string' && document.referrer.includes('android-app://'));
    const hasHoverAndPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);
    const isMobileDevice = isIOS || isAndroid;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isTouchOnly = isTouch && !window.matchMedia('(pointer: fine)').matches;

    let mode: DeviceMode;
    if (isStandalone) {
      mode = 'pwa';
    } else if (hasHoverAndPointer || (width >= 1024 && !isTouchOnly)) {
      mode = 'desktop';
    } else if (isMobileDevice || isTouchOnly) {
      mode = 'mobile-web';
    } else {
      mode = 'desktop';
    }

    return {
      mode,
      isPWA: mode === 'pwa',
      isDesktop: mode === 'desktop',
      isMobileWeb: mode === 'mobile-web',
      isStandalone,
      isTouch,
      screenWidth: width,
      screenHeight: height,
    };
  } catch {
    return { mode: 'desktop', isPWA: false, isDesktop: true, isMobileWeb: false, isStandalone: false, isTouch: false, screenWidth: 1024, screenHeight: 768 };
  }
}

let cachedDeviceInfo: DeviceInfo | null = null;

function getCachedDeviceInfo(): DeviceInfo {
  if (cachedDeviceInfo) return cachedDeviceInfo;
  cachedDeviceInfo = detectDevice();
  return cachedDeviceInfo;
}

export function useDeviceMode(): DeviceInfo {
  return getCachedDeviceInfo();
}

export default useDeviceMode;
